import { type ReactNode, useEffect } from "react";

interface TabVisibilityWrapperProps {
	children: ReactNode;
	/** Callback when user leaves the browser tab */
	onLeftTab: () => void;
}

export const TabVisibilityWrapper = ({
	children,
	onLeftTab,
}: TabVisibilityWrapperProps) => {
	useEffect(() => {
		const handleVisibilityChange = () => {
			if (document.visibilityState === "hidden") {
				onLeftTab();
			}
		};
		document.addEventListener("visibilitychange", handleVisibilityChange);
		return () =>
			document.removeEventListener("visibilitychange", handleVisibilityChange);
	}, [onLeftTab]);

	return <>{children}</>;
};
